import { render } from "./LastAnomalies.vue?vue&type=template&id=06589bfc&scoped=true"
import script from "./LastAnomalies.vue?vue&type=script&lang=js"
export * from "./LastAnomalies.vue?vue&type=script&lang=js"

import "./LastAnomalies.vue?vue&type=style&index=0&id=06589bfc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06589bfc"]])

export default __exports__